module.exports = __webpack_public_path__ + "static/media/rcsi.19c8d400.png";